// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.list-enter-active[data-v-62396bc0],\n.list-leave-active[data-v-62396bc0] {\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n.list-enter[data-v-62396bc0], .list-leave-to[data-v-62396bc0] /* .list-leave-active below version 2.1.8 */ {\n  opacity: 0;\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
